import React from 'react';

const Health = () => {
  // Simple health page for manual checks in browser
  return (
    <div className="p-6">
      <h1 className="text-xl font-medium">Health Check</h1>
      <pre className="mt-4">{"{\"status\": \"ok\"}"}</pre>
    </div>
  );
};

export default Health;
